import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from './modules/material/material.module';
import { PrimeNgModule } from './modules/prime-ng/prime-ng.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';
// import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { MainContentComponent } from './components/layout/main-content/main-content.component';
import {
  HttpClient,
  HttpClientModule
} from '@angular/common/http';

import '@angular/compiler';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireAnalyticsModule, ScreenTrackingService, UserTrackingService, CONFIG } from '@angular/fire/compat/analytics';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SignupComponent } from './components/signup/signup.component';
import { LoginComponent } from './components/login/login.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { EventManagerComponent } from './components/event-manager/event-manager.component';

import { AuthInterceptorProviders } from './_helpers/auth.interceptor';
import { TabViewComponent } from './components/tab-view/tab-view.component';
import { PersonalProfileComponent } from './components/personal-profile/personal-profile.component';
import { CompanyProfileComponent } from './components/company-profile/company-profile.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { VenuesComponent } from './components/venues/venues.component';
import { EventsPanelComponent } from './components/events/events-panel/events-panel.component';
import { EventItemComponent } from './components/events/event-item/event-item.component';
import { VenueItemComponent } from './components/venue-item/venue-item.component';
import { RatingComponent } from './components/rating/rating.component';

import { CapacityComponent } from './components/capacity/capacity.component';
import { PhotoGalleryComponent } from './components/photo-gallery/photo-gallery.component';
import { EventtypesMultiSelectComponent } from './components/eventtypes-multi-select/eventtypes-multi-select.component';
import { SingleSelectVenueComponent } from './components/single-select-venue/single-select-venue.component';
import { EventCapacityDialogComponent } from './components/event-capacity-dialog/event-capacity-dialog.component';
import { ReservationPanelComponent } from './components/reservations/reservation-panel/reservation-panel.component';
import { ReservationItemComponent } from './components/reservations/reservation-item/reservation-item.component';
import { EventDetailsComponent } from './components/event-details/event-details.component';
import { ReservationDetailsDialogComponent } from './components/reservations/reservation-details-dialog/reservation-details-dialog.component';
import { ViewVenueDialogComponent } from './components/view-venue-dialog/view-venue-dialog.component';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { SwitchLanguageDialogComponent } from './components/switch-language-dialog/switch-language-dialog.component';
import { HostItemComponent } from './components/hosts/host-item/host-item.component';
import { HostDialogComponent } from './components/hosts/host-dialog/host-dialog.component';
import { MultiSelectVenueComponent } from './components/multi-select-venue/multi-select-venue.component';
import { MultiSelectHostComponent } from './components/multi-select-host/multi-select-host.component';
import { ViewHostDialogComponent } from './components/hosts/view-host-dialog/view-host-dialog.component';
import { FiremessagingService } from './services/firebase-messaging/firemessaging.service';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SwitchCasesDirective } from './directives/switch-cases.directive';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { LicenceAgrementComponent } from './components/licence-agrement/licence-agrement.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { FaqComponent } from './components/faq/faq.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AdminModule } from './modules/admin/admin.module';
import { ChatModule } from './modules/chat/chat.module';
import { NavbarComponent } from './navbar/navbar.component';
import { DialogService } from 'primeng/dynamicdialog';
import { JwtModule } from '@auth0/angular-jwt';
import { PaymentAndBillsComponent } from './components/payment-and-bills/payment-and-bills.component';
import { StaffMembersComponent } from './components/staff-members/staff-members.component';
import { CompanyCredentialsComponent } from './components/company-credentials/company-credentials.component';
import { NgxStripeModule } from 'ngx-stripe';
import { CheckoutComponent } from './components/payment-and-bills/checkout/checkout/checkout.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CropAndCompressImageDialogComponent } from './components/crop-and-compress-image-dialog/crop-and-compress-image-dialog.component';
import { DateMaskDirectiveDirective } from './directives/date-mask-directive.directive';
import { LoginWithRefreshTokenComponent } from './components/login-with-refresh-token/login-with-refresh-token.component';
import { VenueCapacityDialogComponent } from './components/venue-capacity-dialog/venue-capacity-dialog.component';
import { ReportsComponent } from './components/reports/reports.component';
import {ChartModule} from "primeng/chart";
// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        //  HeaderComponent,
        FooterComponent,
        MainContentComponent,
        SignupComponent,
        LoginComponent,
        PageNotFoundComponent,
        MultiSelectDropdownComponent,
        EventManagerComponent,
        TabViewComponent,
        PersonalProfileComponent,
        CompanyProfileComponent,
        HeaderComponent,
        HeaderComponent,
        VenuesComponent,
        EventsPanelComponent,
        EventItemComponent,
        VenueItemComponent,
        VenueItemComponent,
        RatingComponent,
        VenueItemComponent,
        CapacityComponent,
        PhotoGalleryComponent,
        EventtypesMultiSelectComponent,
        SingleSelectVenueComponent,
        EventCapacityDialogComponent,
        ReservationPanelComponent,
        ReservationItemComponent,
        EventDetailsComponent,
        ReservationDetailsDialogComponent,
        ViewVenueDialogComponent,
        SwitchLanguageDialogComponent,
        HostItemComponent,
        HostDialogComponent,
        MultiSelectVenueComponent,
        MultiSelectHostComponent,
        ViewHostDialogComponent,
        ChangePasswordComponent,
        ForgotPasswordComponent,
        SwitchCasesDirective,
        TermsAndConditionsComponent,
        LicenceAgrementComponent,
        PrivacyPolicyComponent,
        FaqComponent,
        NavbarComponent,
        PaymentAndBillsComponent,
        StaffMembersComponent,
        CompanyCredentialsComponent,
        CheckoutComponent,
        CropAndCompressImageDialogComponent,
        DateMaskDirectiveDirective,
        LoginWithRefreshTokenComponent,
        VenueCapacityDialogComponent,
        ReportsComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        MaterialModule,
        InfiniteScrollModule,
        PrimeNgModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SharedModule,
        NgImageFullscreenViewModule,
        ImageCropperModule,
        AngularFireMessagingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAnalyticsModule,
        NgxStripeModule.forRoot(environment.stripe.publishableKey),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                deps: [HttpClient],
                useFactory: createTranslateLoader
            }
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: () => {
                    return localStorage.getItem("access_token");
                },
            },
        }),
        AdminModule,
        ChatModule,
        ChartModule,
    ],
    exports: [
        HeaderComponent,
        NavbarComponent
    ],
    providers: [AuthInterceptorProviders, FiremessagingService, ScreenTrackingService, UserTrackingService, DialogService],
    bootstrap: [AppComponent]
})
export class AppModule { }
